import actionTypes from "../actionTypes";

export function requestExpiredProgressiveMissions(payload?: any) {
    return {
        type: actionTypes.EXPIRED_PROGRESSIVE_MISSIONS_REQUEST,
        payload
    };
}

export function successExpiredProgressiveMissions(payload: any) {
    return {
        type: actionTypes.EXPIRED_PROGRESSIVE_MISSIONS_SUCCESS,
        payload,
    };
}

export function clearExpiredProgressiveMissions() {
    return {
        type: actionTypes.EXPIRED_PROGRESSIVE_MISSIONS_CLEAR,
    };
}
